/**
 * SKOP API Key Manager
 *
 * Public API access is not yet available.
 * This component shows a placeholder for future API key management.
 */

export function ApiKeyManager() {
  return (
    <div style={{
      padding: '24px',
      background: 'var(--bg-secondary)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      textAlign: 'center',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        margin: '0 auto 16px',
        background: 'var(--bg-tertiary)',
        borderRadius: 'var(--radius-md)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--text-secondary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
        </svg>
      </div>
      <h3 style={{ margin: '0 0 8px', color: 'var(--text-primary)', fontSize: '16px' }}>
        API Access Coming Soon
      </h3>
      <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '14px' }}>
        Programmatic API access with key management will be available in a future update.
      </p>
    </div>
  );
}
